var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center pb-4"},[_vm._v(" "+_vm._s(_vm.bp('textSearchNoResults'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }